import { render, staticRenderFns } from "./AlertTile.vue?vue&type=template&id=c5c1bff6&scoped=true&"
import script from "./AlertTile.vue?vue&type=script&lang=js&"
export * from "./AlertTile.vue?vue&type=script&lang=js&"
import style0 from "./AlertTile.vue?vue&type=style&index=0&id=c5c1bff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c1bff6",
  null
  
)

export default component.exports